import React from 'react';
import './info-box.scss';

const InfoBox = props => {
    return (
        <div className={'box-holder'}>
            <div className={'label-txt'} dangerouslySetInnerHTML={{__html: props.data}} />
        </div>
    )
};

export  default InfoBox;